import { useState, useEffect } from "react";
import "./horizontalStackedBar.scss";
import { Tooltip } from "antd";

interface DataSet {
  dataset: {
    section: string;
    section_id: string;
    color: string;
    total_response: number;
    responses: {
      option: string;
      count: number;
      percent: number;
    }[];
  }[];
}

const HorizontalStackedBar = ({ dataset }: DataSet) => {
  const [data, setData] = useState<
    {
      section: string;
      section_id: string;
      color: string;
      total_response: number;
      responses: {
        option: string;
        count: number;
        percent: number;
      }[];
    }[]
  >(dataset);
  useEffect(() => {
    setData(dataset);
    // eslint-disable-next-line
  }, [dataset]);

  return (
    <div className="horizontalStackedBar">
      {data.map((section: any, index: number) => (
        <div className="stackedContainer" key={index}>
          <span className="label">{section.section}</span>
          {section.total_response > 0 ? (
            <div className="stackedBar">
              <Tooltip title={`${section.responses[0].count} "Yes" answer(s)`}>
                <div
                  className="yesBar"
                  style={{ width: `${section.responses[0].percent}%` }}
                ></div>
              </Tooltip>
              <Tooltip title={`${section.responses[1].count} "No" answer(s)`}>
                <div
                  className="noBar"
                  style={{ width: `${section.responses[1].percent}%` }}
                ></div>
              </Tooltip>
              <Tooltip title={`${section.responses[2].count} "N/A" answer(s)`}>
                <div
                  className="naBar"
                  style={{ width: `${section.responses[2].percent}%` }}
                ></div>
              </Tooltip>
              <Tooltip title={`${section.responses[3].count} "TBD" answer(s)`}>
                <div
                  className="tbdBar"
                  style={{ width: `${section.responses[3].percent}%` }}
                ></div>
              </Tooltip>
            </div>
          ) : (
            <div className="emptyStack">
              No data available because you did not answer questions in this
              section yet
            </div>
          )}
        </div>
      ))}
      <div className="legendContainer">
        <div className="legend">
          <span
            className="circle"
            style={{ backgroundColor: "#B3D588" }}
          ></span>
          <span>Yes</span>
        </div>
        <div className="legend">
          <span
            className="circle"
            style={{ backgroundColor: "#E19083" }}
          ></span>
          <span>No</span>
        </div>
        <div className="legend">
          <span
            className="circle"
            style={{ backgroundColor: "#D8DADF" }}
          ></span>
          <span>N/A</span>
        </div>
        <div className="legend">
          <span
            className="circle"
            style={{ backgroundColor: "#F4C482" }}
          ></span>
          <span>TBD</span>
        </div>
      </div>
    </div>
  );
};

export default HorizontalStackedBar;
